import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = 'membership/partners'

const partnersEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchPartners: builder.query<any, { pageNumber?: number; pageSize?: number }>({
    query: ({ pageNumber = 0, pageSize = 10 } = {}) => ({
      url: `${basePath}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      method: 'get',
    }),
    providesTags: ['partners'],
  }),

  fetchPartnerById: builder.query<any, string | number>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'get',
    }),
    providesTags: ['partners'],
  }),

  createPartner: builder.mutation<any, any>({
    query: (body) => ({
      url: `${basePath}/create`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['partners'],
  }),

  updatePartner: builder.mutation<any, { id: number | string; body: any }>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['partners'],
  }),

  deletePartner: builder.mutation<any, number | string>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['partners'],
  }),

  fetchPartnerMembers: builder.query<any, string | number>({
    query: (partnerId) => ({
      url: `${basePath}/${partnerId}/members`,
      method: 'get',
    }),
    providesTags: ['partners'],
  }),

  createPartnerMember: builder.mutation<any, { partnerId: string | number; body: any }>({
    query: ({ partnerId, body }) => ({
      url: `${basePath}/${partnerId}/members`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['partners'],
  }),

  updatePartnerMember: builder.mutation<any, { partnerId: string | number; memberId: string | number; body: any }>({
    query: ({ partnerId, memberId, body }) => ({
      url: `${basePath}/${partnerId}/members/${memberId}`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['partners'],
  }),

  deletePartnerMember: builder.mutation<any, { partnerId: string | number; memberId: string | number }>({
    query: ({ partnerId, memberId }) => ({
      url: `${basePath}/${partnerId}/members/${memberId}`,
      method: 'delete',
    }),
    invalidatesTags: ['partners'],
  }),
})

export default partnersEndpoints
